<template>
    <sections>
        <section-text heading="Terms & Conditions" content="<article-terms />"></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Terms | ' + $config.public.siteName,
    description: 'The terms and conditions you agree to by using this website.',
    index: false,
});
</script>
